export default {
    A1: {
        t: 's',
        v: '請存成CSV格式前將標題列(列1~10)及所有範例資料刪除',
        r: '<t>請存成CSV格式前將標題列(列1~10)及所有範例資料刪除</t>',
        h: '請存成CSV格式前將標題列(列1~10)及所有範例資料刪除',
        w: '請存成CSV格式前將標題列(列1~10)及所有範例資料刪除',
    },
    A2: {
        t: 'n',
        v: 1,
        w: '1',
    },
    B2: {
        t: 'n',
        v: 2,
        w: '2',
    },
    C2: {
        t: 'n',
        v: 3,
        w: '3',
    },
    D2: {
        t: 'n',
        v: 4,
        w: '4',
    },
    E2: {
        t: 'n',
        v: 5,
        w: '5',
    },
    F2: {
        t: 'n',
        v: 6,
        w: '6',
    },
    G2: {
        t: 'n',
        v: 7,
        w: '7',
    },
    H2: {
        t: 'n',
        v: 8,
        w: '8',
    },
    I2: {
        t: 'n',
        v: 9,
        w: '9',
    },
    J2: {
        t: 'n',
        v: 10,
        w: '10',
    },
    K2: {
        t: 's',
        v: '11  (共用欄位一)',
        r: '<t>11  (共用欄位一)</t>',
        h: '11  (共用欄位一)',
        w: '11  (共用欄位一)',
    },
    N2: {
        t: 'n',
        v: 12,
        w: '12',
    },
    O2: {
        t: 'n',
        v: 13,
        w: '13',
    },
    P2: {
        t: 'n',
        v: 14,
        w: '14',
    },
    Q2: {
        t: 'n',
        v: 15,
        w: '15',
    },
    R2: {
        t: 'n',
        v: 16,
        w: '16',
    },
    S2: {
        t: 'n',
        v: 17,
        w: '17',
    },
    T2: {
        t: 's',
        v: '18  (共用欄位二)',
        r: '<t>18  (共用欄位二)</t>',
        h: '18  (共用欄位二)',
        w: '18  (共用欄位二)',
    },
    Y2: {
        t: 'n',
        v: 19,
        w: '19',
    },
    Z2: {
        t: 'n',
        v: 20,
        w: '20',
    },
    AA2: {
        t: 'n',
        v: 21,
        w: '21',
    },
    AB2: {
        t: 'n',
        v: 22,
        w: '22',
    },
    AC2: {
        t: 'n',
        v: 23,
        w: '23',
    },
    AD2: {
        t: 'n',
        v: 24,
        w: '24',
    },
    AE2: {
        t: 'n',
        v: 25,
        w: '25',
    },
    AF2: {
        t: 'n',
        v: 26,
        w: '26',
    },
    A3: {
        t: 's',
        v: '縣市機關別 (3)',
        r: '<t>縣市機關別 (3)</t>',
        h: '縣市機關別 (3)',
        w: '縣市機關別 (3)',
    },
    B3: {
        t: 's',
        v: '流水號 (8)',
        r: '<t>流水號 (8)</t>',
        h: '流水號 (8)',
        w: '流水號 (8)',
    },
    C3: {
        t: 's',
        v: '申報單位統一編號 (8)',
        r: '<t>申報單位統一編號 (8)</t>',
        h: '申報單位統一編號 (8)',
        w: '申報單位統一編號 (8)',
    },
    D3: {
        t: 's',
        v: '所得註記 (1)',
        r: '<t>所得註記 (1)</t>',
        h: '所得註記 (1)',
        w: '所得註記 (1)',
    },
    E3: {
        t: 's',
        v: '所得格式 (2)',
        r: '<t>所得格式 (2)</t>',
        h: '所得格式 (2)',
        w: '所得格式 (2)',
    },
    F3: {
        t: 's',
        v: '所得人統編 (10)',
        r: '<t>所得人統編 (10)</t>',
        h: '所得人統編 (10)',
        w: '所得人統編 (10)',
    },
    G3: {
        t: 's',
        v: '證號別 (1)',
        r: '<t>證號別 (1)</t>',
        h: '證號別 (1)',
        w: '證號別 (1)',
    },
    H3: {
        t: 's',
        v: '1、扣繳憑單給付總額\r\n2、股利憑單股利總額 (12)',
        r: '<t>1、扣繳憑單給付總額\r\n2、股利憑單股利總額 (12)</t>',
        h: '1、扣繳憑單給付總額&#x000d;<br/>2、股利憑單股利總額 (12)',
        w: '1、扣繳憑單給付總額\r\n2、股利憑單股利總額 (12)',
    },
    I3: {
        t: 's',
        v: '1、扣繳憑單扣繳稅額\r\n2、股利憑單可扣抵稅額 (12)',
        r: '<t>1、扣繳憑單扣繳稅額\r\n2、股利憑單可扣抵稅額 (12)</t>',
        h: '1、扣繳憑單扣繳稅額&#x000d;<br/>2、股利憑單可扣抵稅額 (12)',
        w: '1、扣繳憑單扣繳稅額\r\n2、股利憑單可扣抵稅額 (12)',
    },
    J3: {
        t: 's',
        v: '1、扣繳憑單給付淨額\r\n2、股利憑單股利淨額 (12)',
        r: '<t>1、扣繳憑單給付淨額\r\n2、股利憑單股利淨額 (12)</t>',
        h: '1、扣繳憑單給付淨額&#x000d;<br/>2、股利憑單股利淨額 (12)',
        w: '1、扣繳憑單給付淨額\r\n2、股利憑單股利淨額 (12)',
    },
    K3: {
        t: 's',
        v: '所得人代號(或帳號)或外僑護照號碼  (12)',
        r: '<t>所得人代號(或帳號)或外僑護照號碼  (12)</t>',
        h: '所得人代號(或帳號)或外僑護照號碼  (12)',
        w: '所得人代號(或帳號)或外僑護照號碼  (12)',
    },
    N3: {
        t: 's',
        v: '軟體註記 (1)',
        r: '<t>軟體註記 (1)</t>',
        h: '軟體註記 (1)',
        w: '軟體註記 (1)',
    },
    O3: {
        t: 's',
        v: '錯誤註記 (1)',
        r: '<t>錯誤註記 (1)</t>',
        h: '錯誤註記 (1)',
        w: '錯誤註記 (1)',
    },
    P3: {
        t: 's',
        v: '所得給付年度 (3)',
        r: '<t>所得給付年度 (3)</t>',
        h: '所得給付年度 (3)',
        w: '所得給付年度 (3)',
    },
    Q3: {
        t: 's',
        v: '所得人姓名\n[全部全形或全部半形]  (50)',
        r: '<t>所得人姓名\n[全部全形或全部半形]  (50)</t>',
        h: '所得人姓名<br/>[全部全形或全部半形]  (50)',
        w: '所得人姓名\n[全部全形或全部半形]  (50)',
    },
    R3: {
        t: 's',
        v: '所得人地址\n[全部全形或全部半形] (100)',
        r: '<t>所得人地址\n[全部全形或全部半形] (100)</t>',
        h: '所得人地址<br/>[全部全形或全部半形] (100)',
        w: '所得人地址\n[全部全形或全部半形] (100)',
    },
    S3: {
        t: 's',
        v: '所得所屬期間(10)',
        r: '<t>所得所屬期間(10)</t>',
        h: '所得所屬期間(10)',
        w: '所得所屬期間(10)',
    },
    T3: {
        t: 's',
        v: '所得格式 50E 時需填',
        r: '<t>所得格式 50E 時需填</t>',
        h: '所得格式 50E 時需填',
        w: '所得格式 50E 時需填',
    },
    Y3: {
        t: 's',
        v: '扣抵稅額註記 (1)',
        r: '<t>扣抵稅額註記 (1)</t>',
        h: '扣抵稅額註記 (1)',
        w: '扣抵稅額註記 (1)',
    },
    Z3: {
        t: 's',
        v: '憑單填發方式 (1)',
        r: '<t>憑單填發方式 (1)</t>',
        h: '憑單填發方式 (1)',
        w: '憑單填發方式 (1)',
    },
    AA3: {
        t: 's',
        v: '是否滿183天 (1)',
        r: '<t>是否滿183天 (1)</t>',
        h: '是否滿183天 (1)',
        w: '是否滿183天 (1)',
    },
    AB3: {
        t: 's',
        v: '居住地國或地區代碼 (2)',
        r: '<t>居住地國或地區代碼 (2)</t>',
        h: '居住地國或地區代碼 (2)',
        w: '居住地國或地區代碼 (2)',
    },
    AC3: {
        t: 's',
        v: '租稅協定代碼 (2)',
        r: '<t>租稅協定代碼 (2)</t>',
        h: '租稅協定代碼 (2)',
        w: '租稅協定代碼 (2)',
    },
    AD3: {
        t: 's',
        v: '空白 (0)',
        r: '<t>空白 (0)</t>',
        h: '空白 (0)',
        w: '空白 (0)',
    },
    AE3: {
        t: 's',
        v: '1、檔案製作日期\n2、非居住者所得給付月日\n3、決算核准函日期\n4、清算完結日期 (4)',
        r: '<t>1、檔案製作日期\n2、非居住者所得給付月日\n3、決算核准函日期\n4、清算完結日期 (4)</t>',
        h: '1、檔案製作日期<br/>2、非居住者所得給付月日<br/>3、決算核准函日期<br/>4、清算完結日期 (4)',
        w: '1、檔案製作日期\n2、非居住者所得給付月日\n3、決算核准函日期\n4、清算完結日期 (4)',
    },
    AF3: {
        t: 's',
        v: '稅務識別碼(30)',
        r: '<t>稅務識別碼(30)</t>',
        h: '稅務識別碼(30)',
        w: '稅務識別碼(30)',
    },
    T4: {
        t: 's',
        v: '員工分紅資料-\r\n股數 (10)',
        r: '<t>員工分紅資料-\r\n股數 (10)</t>',
        h: '員工分紅資料-&#x000d;<br/>股數 (10)',
        w: '員工分紅資料-\r\n股數 (10)',
    },
    U4: {
        t: 's',
        v: '交付股票-\n年月日 (7)',
        r: '<t>交付股票-\n年月日 (7)</t>',
        h: '交付股票-<br/>年月日 (7)',
        w: '交付股票-\n年月日 (7)',
    },
    V4: {
        t: 's',
        v: '交付股票日之每股時價 (11)',
        r: '<t>交付股票日之每股時價 (11)</t>',
        h: '交付股票日之每股時價 (11)',
        w: '交付股票日之每股時價 (11)',
    },
    K5: {
        t: 's',
        v: '租賃房屋稅籍編號',
        r: '<t>租賃房屋稅籍編號</t>',
        h: '租賃房屋稅籍編號',
        w: '租賃房屋稅籍編號',
    },
    T5: {
        t: 's',
        v: '所得格式 54F 時需填',
        r: '<t>所得格式 54F 時需填</t>',
        h: '所得格式 54F 時需填',
        w: '所得格式 54F 時需填',
    },
    K6: {
        t: 's',
        v: '縣市 (1) 鄉鎮 (2) 村里 (2)棟戶號(冊頁號) (7)',
        r: '<t>縣市 (1) 鄉鎮 (2) 村里 (2)棟戶號(冊頁號) (7)</t>',
        h: '縣市 (1) 鄉鎮 (2) 村里 (2)棟戶號(冊頁號) (7)',
        w: '縣市 (1) 鄉鎮 (2) 村里 (2)棟戶號(冊頁號) (7)',
    },
    T6: {
        t: 's',
        v: '應扣繳稅額 (12)',
        r: '<t>應扣繳稅額 (12)</t>',
        h: '應扣繳稅額 (12)',
        w: '應扣繳稅額 (12)',
    },
    U6: {
        t: 's',
        v: '股利或盈餘抵繳稅額 (12)',
        r: '<t>股利或盈餘抵繳稅額 (12)</t>',
        h: '股利或盈餘抵繳稅額 (12)',
        w: '股利或盈餘抵繳稅額 (12)',
    },
    K7: {
        t: 's',
        v: '執行業務者業別、稿費必要費用別、其他所得給付項目代號',
        r: '<t>執行業務者業別、稿費必要費用別、其他所得給付項目代號</t>',
        h: '執行業務者業別、稿費必要費用別、其他所得給付項目代號',
        w: '執行業務者業別、稿費必要費用別、其他所得給付項目代號',
    },
    T7: {
        t: 's',
        v: '所得格式 50 時需填\t\t\t\t',
        r: '<t xml:space="preserve">所得格式 50 時需填\t\t\t\t</t>',
        h: '所得格式 50 時需填&#x0009;&#x0009;&#x0009;&#x0009;',
        w: '所得格式 50 時需填\t\t\t\t',
    },
    K8: {
        t: 's',
        v: '代號 (2)',
        r: '<t>代號 (2)</t>',
        h: '代號 (2)',
        w: '代號 (2)',
    },
    T8: {
        t: 's',
        v: '依勞退條例自願提繳之退休金額 (12)',
        r: '<t>依勞退條例自願提繳之退休金額 (12)</t>',
        h: '依勞退條例自願提繳之退休金額 (12)',
        w: '依勞退條例自願提繳之退休金額 (12)',
    },
    K9: {
        t: 's',
        v: '87或以後年度股利分配 ',
        r: '<t xml:space="preserve">87或以後年度股利分配 </t>',
        h: '87或以後年度股利分配 ',
        w: '87或以後年度股利分配 ',
    },
    T9: {
        t: 's',
        v: '所得格式 54C 時需填',
        r: '<t>所得格式 54C 時需填</t>',
        h: '所得格式 54C 時需填',
        w: '所得格式 54C 時需填',
    },
    K10: {
        t: 's',
        v: '稅額扣抵比率% \n[小數點前後2位] (5)',
        r: '<t>稅額扣抵比率% \n[小數點前後2位] (5)</t>',
        h: '稅額扣抵比率% <br/>[小數點前後2位] (5)',
        w: '稅額扣抵比率% \n[小數點前後2位] (5)',
    },
    L10: {
        t: 's',
        v: '分配次數 (1)',
        r: '<t>分配次數 (1)</t>',
        h: '分配次數 (1)',
        w: '分配次數 (1)',
    },
    M10: {
        t: 's',
        v: '除權(息)基準-\n年月日 (7)',
        r: '<t>除權(息)基準-\n年月日 (7)</t>',
        h: '除權(息)基準-<br/>年月日 (7)',
        w: '除權(息)基準-\n年月日 (7)',
    },
    T10: {
        t: 's',
        v: '其他現金股利 (12)',
        r: '<t>其他現金股利 (12)</t>',
        h: '其他現金股利 (12)',
        w: '其他現金股利 (12)',
    },
    U10: {
        t: 's',
        v: '資本公積現金股利 (12)',
        r: '<t>資本公積現金股利 (12)</t>',
        h: '資本公積現金股利 (12)',
        w: '資本公積現金股利 (12)',
    },
    V10: {
        t: 's',
        v: '股票股利 (12)',
        r: '<t>股票股利 (12)</t>',
        h: '股票股利 (12)',
        w: '股票股利 (12)',
    },
    W10: {
        t: 's',
        v: '股票股利股數 (10)',
        r: '<t>股票股利股數 (10)</t>',
        h: '股票股利股數 (10)',
        w: '股票股利股數 (10)',
    },
    '!ref': 'A1:AF14',
    '!merges': [
        {
            s: {
                c: 29,
                r: 2,
            },
            e: {
                c: 29,
                r: 9,
            },
        },
        {
            s: {
                c: 30,
                r: 2,
            },
            e: {
                c: 30,
                r: 9,
            },
        },
        {
            s: {
                c: 31,
                r: 2,
            },
            e: {
                c: 31,
                r: 9,
            },
        },
        {
            s: {
                c: 19,
                r: 4,
            },
            e: {
                c: 23,
                r: 4,
            },
        },
        {
            s: {
                c: 19,
                r: 6,
            },
            e: {
                c: 23,
                r: 6,
            },
        },
        {
            s: {
                c: 19,
                r: 1,
            },
            e: {
                c: 23,
                r: 1,
            },
        },
        {
            s: {
                c: 19,
                r: 2,
            },
            e: {
                c: 23,
                r: 2,
            },
        },
        {
            s: {
                c: 24,
                r: 2,
            },
            e: {
                c: 24,
                r: 9,
            },
        },
        {
            s: {
                c: 25,
                r: 2,
            },
            e: {
                c: 25,
                r: 9,
            },
        },
        {
            s: {
                c: 26,
                r: 2,
            },
            e: {
                c: 26,
                r: 9,
            },
        },
        {
            s: {
                c: 27,
                r: 2,
            },
            e: {
                c: 27,
                r: 9,
            },
        },
        {
            s: {
                c: 28,
                r: 2,
            },
            e: {
                c: 28,
                r: 9,
            },
        },
        {
            s: {
                c: 19,
                r: 8,
            },
            e: {
                c: 23,
                r: 8,
            },
        },
        {
            s: {
                c: 4,
                r: 2,
            },
            e: {
                c: 4,
                r: 9,
            },
        },
        {
            s: {
                c: 5,
                r: 2,
            },
            e: {
                c: 5,
                r: 9,
            },
        },
        {
            s: {
                c: 6,
                r: 2,
            },
            e: {
                c: 6,
                r: 9,
            },
        },
        {
            s: {
                c: 7,
                r: 2,
            },
            e: {
                c: 7,
                r: 9,
            },
        },
        {
            s: {
                c: 8,
                r: 2,
            },
            e: {
                c: 8,
                r: 9,
            },
        },
        {
            s: {
                c: 9,
                r: 2,
            },
            e: {
                c: 9,
                r: 9,
            },
        },
        {
            s: {
                c: 10,
                r: 2,
            },
            e: {
                c: 12,
                r: 3,
            },
        },
        {
            s: {
                c: 13,
                r: 2,
            },
            e: {
                c: 13,
                r: 9,
            },
        },
        {
            s: {
                c: 10,
                r: 4,
            },
            e: {
                c: 12,
                r: 4,
            },
        },
        {
            s: {
                c: 10,
                r: 5,
            },
            e: {
                c: 12,
                r: 5,
            },
        },
        {
            s: {
                c: 10,
                r: 6,
            },
            e: {
                c: 12,
                r: 6,
            },
        },
        {
            s: {
                c: 10,
                r: 8,
            },
            e: {
                c: 12,
                r: 8,
            },
        },
        {
            s: {
                c: 14,
                r: 2,
            },
            e: {
                c: 14,
                r: 9,
            },
        },
        {
            s: {
                c: 15,
                r: 2,
            },
            e: {
                c: 15,
                r: 9,
            },
        },
        {
            s: {
                c: 16,
                r: 2,
            },
            e: {
                c: 16,
                r: 9,
            },
        },
        {
            s: {
                c: 17,
                r: 2,
            },
            e: {
                c: 17,
                r: 9,
            },
        },
        {
            s: {
                c: 0,
                r: 0,
            },
            e: {
                c: 7,
                r: 0,
            },
        },
        {
            s: {
                c: 10,
                r: 1,
            },
            e: {
                c: 12,
                r: 1,
            },
        },
        {
            s: {
                c: 0,
                r: 2,
            },
            e: {
                c: 0,
                r: 9,
            },
        },
        {
            s: {
                c: 1,
                r: 2,
            },
            e: {
                c: 1,
                r: 9,
            },
        },
        {
            s: {
                c: 2,
                r: 2,
            },
            e: {
                c: 2,
                r: 9,
            },
        },
        {
            s: {
                c: 3,
                r: 2,
            },
            e: {
                c: 3,
                r: 9,
            },
        },
        {
            s: {
                c: 18,
                r: 2,
            },
            e: {
                c: 18,
                r: 9,
            },
        },
        {
            s: {
                c: 19,
                r: 7,
            },
            e: {
                c: 23,
                r: 7,
            },
        },
        {
            s: {
                c: 22,
                r: 9,
            },
            e: {
                c: 23,
                r: 9,
            },
        },
    ],

    // EMPTY STORAGE BLOCK
    L2: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M2: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    U2: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V2: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W2: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X2: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    U8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L3: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M3: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    U3: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V3: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W3: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X3: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    K4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF4: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    U5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF5: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF6: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    U7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF7: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF8: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    L9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    M9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    U9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    V9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    W9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF9: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    A10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    B10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    C10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    D10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    E10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    F10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    G10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    H10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    I10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    J10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    N10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    O10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    P10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Q10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    R10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    S10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    X10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Y10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    Z10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AA10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AB10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AC10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AD10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AE10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
    AF10: {
        t: 's',
        v: '',
        h: '',
        w: '',
    },
};
